const config = {
  ENV: 'PROD',
  VER: 'V1',
  API_PATH: 'vrcci.ru',
  VRCCI_JWT:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOnsiZGF0ZSI6IjIwMjMtMDItMDEgMTM6NTE6MjQuMjk0Njg0IiwidGltZXpvbmVfdHlwZSI6MywidGltZXpvbmUiOiJFdXJvcGVcL01vc2NvdyJ9LCJpc3MiOiJ2cmNjaS5ydTo0NDMiLCJuYmYiOnsiZGF0ZSI6IjIwMjMtMDItMDEgMTM6NTE6MjQuMjk0Njg0IiwidGltZXpvbmVfdHlwZSI6MywidGltZXpvbmUiOiJFdXJvcGVcL01vc2NvdyJ9LCJ1c2VyIjoiMSJ9.4gmWHmsd1Y-TPBurRMXo9wsF92rnBtf2OunbLEfy9nuHr-LBtE_Yczq8WtGDF3fnn9mvXYJeucKVKl6Unn2jhQ',
}
export default config
